import React, { useEffect, useState } from "react";
import Table from "../Table/Table";
import Table_Buttons from "../Table_Button/Table_button";
import { toast } from "react-toastify";
import { API } from "../../Redux/actions/API";
import Navbar from "../Navbar/Navbar";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import DOMPurify from "dompurify";

export default function NewCoin() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  // let user = "";
  const [referralApi, setreferralApi] = useState([]);
  const [leftreferralApi, setleftreferralApi] = useState([]);

  const [coinname, setcoinname] = useState("");
  const [coinsymbol, setcoinsymbol] = useState("");
  const [coindiscription, setcoindiscription] = useState("");
  const [coinrate, setcoinrate] = useState("");
  const [cointype, setcointype] = useState("");

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [currentPage, setcurrentPage] = useState(1);
  const [listPerpage, setlistPerpage] = useState(10);
  const [currentPage2, setcurrentPage2] = useState(1);
  const [listPerpage2, setlistPerpage2] = useState(10);

  const referral_API = async (type) => {
    try {
      if (type === "1") {
        let responceRight = await API?.post(
          "/CoinListAPI",
          {
            loginid: userId,
            type: "3",
          },
          {
            headers: {
              Authorization: jwt_token,
            },
          }
        );

        responceRight = responceRight.data.data[0];

        setleftreferralApi([]);
        let arrayLeft = [];

        responceRight.forEach((item, index) => {
          arrayLeft.push({
            sr: index + 1,
            coin_name: item?.coin_name,
            coin_symbol: item?.coin_symbol,
            coin_discription: item?.coin_discription,
            coin_rate: item?.coin_rate,
            coin_type: item?.remark,
            edate: item?.edate,
            Disable:
          item.status === 1 ? (
            <button className="btn btn-sm btn-success" onClick={() => UpdateCoinStatus_API({ type: 1, cid: item.id })}>
             Disable
            </button>
          ) : 
          (
            <button
              className="btn btn-sm btn-danger"
              onClick={() => UpdateCoinStatus_API({ type: 2, cid: item.id })}>
             Enable
            </button>
          ),
          });

          setleftreferralApi(arrayLeft);
        });
      } else if (type === "2") {
        let responceRight = await API?.post(
          "/Add_CoinByAdmin",
          {
            loginid: userId,
            coinname: coinname,
            coinsymbol: coinsymbol,
            coindiscription: coindiscription,
            coinrate: coinrate,
            cointype: cointype,
          },
          {
            headers: {
              Authorization: jwt_token,
            },
          }
        );
        responceRight = responceRight.data.data;
        console.clear();
        console.log("responceRight-->", responceRight);
        if (responceRight === "SUCCESSFUL") {
          toast.success(responceRight);
          referral_API("1");
          setcoinname("");
          setcoinsymbol("");
          setcoindiscription("");
          setcoinrate("");
          setcointype("");
        } else {
          toast.error(responceRight);
        }
      }
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };


   const UpdateCoinStatus_API = async ({cid, type}) => {
      try {
        let responceRight = await API?.post(
          "UpdateCoinStatus",
          {
            loginid: userId,
            CoinId: cid,

            type: type,
          },
          {
            headers: {
              Authorization: jwt_token,
            },
          }
        );
        // console.clear();
        // console.log("responceRight-->", responceRight.data.data);
        // responceRight = responceRight.data.data[0];
toast.success(responceRight.data.data.result);
referral_API("1");
       
      } catch (error) {
        console.log("Country API ERROR", error);
      }
    };

  useEffect(() => {
    referral_API("1");
  }, []);

  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;
  const indexOfLastPost2 = currentPage2 * listPerpage2;
  const indexOfFirstPage2 = indexOfLastPost2 - listPerpage2;
  const currentPost = referralApi.slice(indexOfFirstPage, indexOfLastPost);
  const currentPostleft = leftreferralApi.slice(
    indexOfFirstPage2,
    indexOfLastPost2
  );

  var [my_team, set_my_team] = new useState({
    cols: [
      { Header: "S.No.", accessor: "sr" },
      { Header: "Coin Name", accessor: "coin_name" },
      { Header: "Coin Symbol", accessor: "coin_symbol" },
      { Header: "Description", accessor: "coin_discription" },
      { Header: "Coin Rate", accessor: "coin_rate" },
      { Header: "Coin Type", accessor: "coin_type" },
      { Header: "Date", accessor: "edate" },
      { Header: "Function", accessor: "Disable" },

    ],
  });

  return (
    <div>
      <Navbar />
      <div class="content-page content_page_hit">
        <div class="content">
          <div class="container">
            {/* <-- inline Form --> */}
            <div class="row">
              <div class="col-md-12">
                <div class="panel panel-primary">
                  <div class="panel-heading">
                    <h4 class="panel-title">Add New Coin</h4>
                  </div>
                  <div class="panel-body">
                    <form
                      action="/Admin/BulkRegistration"
                      method="post"
                      class="ng-pristine in-ip-1 ng-valid"
                    >
                      <div class="form-inline" role="form">
                        <div class="col-md-12">
                          <div class="col-lg-2 col-xl-2 col-md-3">
                            <label>Coin Name:</label>
                            <br />
                            <input
                              class="form-control in-ip-1"
                              id="uid"
                              onChange={(e) => {
                                setcoinname(e.target.value);
                              }}
                              name="uid"
                              placeholder="Coin Name"
                              type="text"
                              value={coinname}
                            />
                          </div>
                          <div class="col-lg-2 col-xl-2 col-md-3">
                            <label>Coin Symbol:</label>
                            <br />
                            <input
                              class="form-control in-ip-1"
                              id="uid"
                              onChange={(e) => {
                                setcoinsymbol(e.target.value);
                              }}
                              name="uid"
                              placeholder="Coin Symbol"
                              type="text"
                              value={coinsymbol}
                            />
                          </div>
                          <div class="col-lg-2 col-xl-2 col-md-3">
                            <label>Description:</label>
                            <br />
                            <input
                              class="form-control in-ip-1"
                              id="uid"
                              onChange={(e) => {
                                setcoindiscription(e.target.value);
                              }}
                              name="uid"
                              placeholder="Description"
                              type="text"
                              value={coindiscription}
                            />
                          </div>
                          <div class="col-lg-2 col-xl-2 col-md-3">
                            <label>Coin Rate:</label>
                            <br />
                            <input
                              class="form-control in-ip-1"
                              id="uid"
                              onChange={(e) => {
                                setcoinrate(e.target.value);
                              }}
                              name="uid"
                              placeholder="Coin Rate"
                              type="text"
                              value={coinrate}
                            />
                          </div>
                          <div class="col-lg-2 col-xl-2 col-md-3">
                            <label>Coin Type:</label>
                            <br />
                            <select
                              name="Amount"
                              className="form-control"
                              value={cointype}
                              onChange={(e) => {
                                setcointype(e.target.value);
                              }}
                            >
                              <option value="">Coin type</option>
                              <option value="local">Local</option>
                              <option value="live">Live</option>
                            </select>
                          </div>

                          <div class="col-lg-2 col-xl-2 col-md-3">
                            <br />
                            <input
                              type="reset"
                              id="btnsearch"
                              formmethod="get"
                              onClick={() => referral_API("2")}
                              class="btn btn-lg btn-primary"
                              value="Add Coin"
                            />
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="panel panel-default">
                  <div class="panel-body" style={{ overflow: "scroll" }}>
                    <Table data={currentPostleft} columns={my_team.cols} />

                    <Table_Buttons
                      indexOfFirstPage={indexOfFirstPage2}
                      indexOfLastPost={indexOfLastPost2}
                      setcurrentPage={setcurrentPage2}
                      currentPage={currentPage2}
                      totalData={leftreferralApi.length}
                      listPerpage={listPerpage2}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
